import * as THREE from 'three';
import { woodMap } from "../material";
const loader = new THREE.TextureLoader();
const textureCache = new Map();
function loadTexture(url, repeat, offset, srgb = false) {
    const key = `${url}|${repeat?.join(',') ?? ''}|${offset?.join(',') ?? ''}|${srgb}`;
    const cached = textureCache.get(key);
    if (cached)
        return cached;
    const t = loader.load(url);
    t.wrapS = t.wrapT = THREE.RepeatWrapping;
    if (srgb)
        t.colorSpace = THREE.SRGBColorSpace;
    if (repeat)
        t.repeat.set(repeat[0], repeat[1]);
    if (offset)
        t.offset.set(offset[0], offset[1]);
    textureCache.set(key, t);
    return t;
}
function fromMaterialDTO(dto) {
    const mat = new THREE.MeshStandardMaterial();
    // diffuse-текстура: из DTO, иначе дефолтный woodMap
    if (dto.textureUrl) {
        mat.map = loadTexture(dto.textureUrl, dto.textureRepeat, dto.textureOffset ?? undefined, true);
    }
    else if (dto.textureUrl === null) {
        mat.map = null; // явно без текстуры
    }
    else {
        mat.map = woodMap; // дефолт
    }
    // normal-карта
    if (dto.normalUrl) {
        mat.normalMap = loadTexture(dto.normalUrl, dto.textureRepeat, dto.textureOffset ?? undefined, false);
        mat.normalMapType = THREE.TangentSpaceNormalMap; // синие tangent-space нормали (ambientCG/PolyHaven)
    }
    if (dto.color !== undefined)
        mat.color.setHex(dto.color);
    if (dto.opacity !== undefined) {
        mat.opacity = dto.opacity;
        mat.transparent = dto.opacity < 1;
    }
    if (dto.metalness !== undefined)
        mat.metalness = dto.metalness;
    if (dto.roughness !== undefined)
        mat.roughness = dto.roughness;
    if (dto.roughnessUrl)
        mat.roughnessMap = loadTexture(dto.roughnessUrl, dto.textureRepeat, dto.textureOffset ?? undefined, false);
    if (dto.metalnessUrl)
        mat.metalnessMap = loadTexture(dto.metalnessUrl, dto.textureRepeat, dto.textureOffset ?? undefined, false);
    mat.userData.id = dto.id;
    mat.needsUpdate = true;
    return mat;
}
function fromVec3DTOToMPos(dto) {
    return [dto.x, dto.y, dto.z];
}
function fromVec3DTOToMRot(dto) {
    return [dto.x, dto.y, dto.z];
}
export function fromRenderStructDTO(dto) {
    // console.log(dto)
    return {
        vertices: dto.vertices,
        indices: dto.indices,
        uvs: dto.uvs,
        group: dto.group,
        position: dto.position ? fromVec3DTOToMPos(dto.position) : undefined,
        rotation: dto.rotation ? fromVec3DTOToMRot(dto.rotation) : undefined,
        material: dto.material.map(fromMaterialDTO),
        elements: dto.elements.map(el => ({
            indices: el.indices,
            vertices: el.vertices,
            name: el.name,
            nameGroup: el.nameGroup,
            position: fromVec3DTOToMPos(el.position),
            rotation: fromVec3DTOToMRot(el.rotation),
            uvs: el.uvs,
            material: el.material,
            specId: el.specId,
        })),
        specIds: dto.specIds,
    };
}
export function fromRenderStructDTOArray(dtos) {
    return dtos.map(fromRenderStructDTO);
}
